import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const dict = {
  en: {
    // Header / nav
    "nav.findTrainers": "Find Trainers",
    "nav.myBookings": "My Bookings",
    "nav.trainerHub": "Trainer Hub",
    "nav.admin": "Admin",
    "nav.signin": "Sign in",
    "nav.getStarted": "Get Started",
    "common.signOut": "Sign out",
    // Landing
    "landing.tag": "Driving Learning · Canada-wide",
    "landing.h1.a": "Find a verified",
    "landing.h1.b": "driving trainer",
    "landing.h1.c": "across Canada.",
    "landing.sub": "Search trainers by province and city — from Vancouver to St. John's. Book lessons or packages, pay upfront in CAD, start with an OTP, finish confident.",
    "landing.findCta": "Find a trainer",
    "landing.becomeCta": "Become a trainer",
    "landing.coverage": "Coverage",
    "landing.provinces": "10 provinces + 3 territories",
    "landing.zones": "34 city zones across Canada",
    // Misc
    "footer.tagline": "Canada's marketplace for verified driving trainers. Search by province, book single lessons or packages, and pay securely in CAD.",
    "footer.contact": "Contact",
    "footer.proudly": "Proudly built in Canada · Prices in CAD",
    "lang.en": "English",
    "lang.fr": "Français",
    "lang.switchTo": "Switch language",
  },
  fr: {
    "nav.findTrainers": "Trouver un instructeur",
    "nav.myBookings": "Mes réservations",
    "nav.trainerHub": "Espace instructeur",
    "nav.admin": "Admin",
    "nav.signin": "Connexion",
    "nav.getStarted": "Commencer",
    "common.signOut": "Déconnexion",
    "landing.tag": "Apprentissage de la conduite · Partout au Canada",
    "landing.h1.a": "Trouvez un",
    "landing.h1.b": "moniteur certifié",
    "landing.h1.c": "partout au Canada.",
    "landing.sub": "Recherchez des moniteurs par province et ville — de Vancouver à St. John's. Réservez des leçons ou des forfaits, payez d'avance en CAD, commencez avec un OTP.",
    "landing.findCta": "Trouver un moniteur",
    "landing.becomeCta": "Devenir moniteur",
    "landing.coverage": "Couverture",
    "landing.provinces": "10 provinces + 3 territoires",
    "landing.zones": "34 zones urbaines au Canada",
    "footer.tagline": "La place de marché canadienne des moniteurs de conduite vérifiés. Cherchez par province, réservez des leçons individuelles ou des forfaits, payez en CAD.",
    "footer.contact": "Contact",
    "footer.proudly": "Fièrement bâti au Canada · Prix en CAD",
    "lang.en": "English",
    "lang.fr": "Français",
    "lang.switchTo": "Changer de langue",
  },
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "en");
  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("lang", lang);
  }, [lang]);
  const t = useCallback((k) => (dict[lang] && dict[lang][k]) || dict.en[k] || k, [lang]);
  const setLang = useCallback((l) => setLangState(l === "fr" ? "fr" : "en"), []);
  // Memoised so every consumer of this context doesn't re-render whenever the
  // provider happens to re-render.
  const value = useMemo(() => ({ lang, t, setLang }), [lang, t, setLang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
